import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import WalletExplorer from "./WalletExplorer";
import WalletHistory from "./WalletHistory";
import { useWallet } from "@solana/wallet-adapter-react";
import "./SimulacrumExplorerStyle.css";

function WalletDashboard() {
    const { walletAddress } = useParams();
    const wallet = useWallet();
    const navigate = useNavigate();

    const [searchAddress, setSearchAddress] = useState("");
    const [recentAddresses, setRecentAddresses] = useState([]);

    // Load recent searches on mount
    useEffect(() => {
        try {
            const stored = localStorage.getItem("recentWalletSearches");
            if (stored) {
                const parsed = JSON.parse(stored);
                if (Array.isArray(parsed)) {
                    setRecentAddresses(parsed);
                }
            }
        } catch (e) {
            console.warn("Failed to parse recentWalletSearches from localStorage", e);
        }
    }, []);

    const updateRecentAddresses = (address) => {
        const trimmed = address.trim();
        setRecentAddresses((prev) => {
            const filtered = prev.filter((a) => a !== trimmed);
            const next = [trimmed, ...filtered];
            if (next.length > 5) next.length = 5;

            try {
                localStorage.setItem("recentWalletSearches", JSON.stringify(next));
            } catch (e) {
                console.warn("Failed to save recentWalletSearches", e);
            }

            return next;
        });
    };

    const handleSearch = () => {
        const trimmed = searchAddress.trim();
        if (!trimmed) return;

        updateRecentAddresses(trimmed);
        navigate(`/dashboard/${trimmed}`);
    };

    const handleRecentClick = (address) => {
        setSearchAddress(address);
        navigate(`/dashboard/${address}`);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleSearch();
    };

    const connectedWalletAddress = wallet.publicKey?.toBase58();
    const currentAddress = walletAddress || connectedWalletAddress;

    return (
        <div>
            <h3>Search wallets by public key or .sol domain(It will take a few minutes to load depending on the number of assets)</h3>

            {/* Search Bar */}
            <div className="search-bar-container">
                <input
                    type="text"
                    placeholder="Enter wallet address"
                    value={searchAddress}
                    onChange={(e) => setSearchAddress(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <button onClick={handleSearch}>Search</button>
            </div>

            {/* Recently searched list */}
            {recentAddresses.length > 0 && (
                <div className="recent-searches-container">
                    <p className="recent-searches-label">Recently searched:</p>
                    <div className="recent-searches-list">
                        {recentAddresses.map((addr) => (
                            <button
                                key={addr}
                                className="recent-search-item"
                                onClick={() => handleRecentClick(addr)}
                            >
                                <p>
                                {addr}
                                </p>
                            </button>
                        ))}
                    </div>
                </div>
            )}

            {/* Show connected wallet message */}
            {!walletAddress && connectedWalletAddress && (
                <div className='connected-wallet-text-container'>
                    <p id='connected-wallet-text'>
                        Viewing data for your connected wallet: <strong>{connectedWalletAddress}</strong>
                    </p>
                </div>
            )}

            {/* Render view */}
            {currentAddress ? (
                <div className='wallet-explorer-outer-app'>
                    <WalletExplorer publicKey={currentAddress} />
                    {/*<WalletHistory publicKey={currentAddress} />*/}
                </div>
            ) : (
                <p>Please connect your wallet or search for an account to view data.</p>
            )}
        </div>
    );
}

export default WalletDashboard;
